/** ISO 639 language list — mirrors backend `demo/lib/lang.py::LANGUAGES`. */
export const LANGUAGES: { code: string; label: string }[] = [
  { code: 'aa', label: 'Afar' },
  { code: 'ady', label: 'Adyghe' },
  { code: 'af', label: 'Afrikaans' },
  { code: 'ak', label: 'Akan' },
  { code: 'am', label: 'Amharic' },
  { code: 'ar', label: 'Arabic' },
  { code: 'arc', label: 'Official Aramaic (700-300 BCE)' },
  { code: 'as', label: 'Assamese' },
  { code: 'av', label: 'Avaric' },
  { code: 'ay', label: 'Aymara' },
  { code: 'az', label: 'Azerbaijani' },
  { code: 'ba', label: 'Bashkir' },
  { code: 'bal', label: 'Baluchi' },
  { code: 'be', label: 'Belarusian' },
  { code: 'bem', label: 'Bemba (Zambia)' },
  { code: 'ber', label: 'Berber languages' },
  { code: 'bg', label: 'Bulgarian' },
  { code: 'bh', label: 'Bihari languages' },
  { code: 'bho', label: 'Bhojpuri' },
  { code: 'bi', label: 'Bislama' },
  { code: 'bik', label: 'Bikol' },
  { code: 'bm', label: 'Bambara' },
  { code: 'bn', label: 'Bengali' },
  { code: 'br', label: 'Breton' },
  { code: 'bs', label: 'Bosnian' },
  { code: 'bua', label: 'Buriat' },
  { code: 'ca', label: 'Catalan' },
  { code: 'cau', label: 'Caucasian languages' },
  { code: 'ce', label: 'Chechen' },
  { code: 'ceb', label: 'Cebuano' },
  { code: 'ch', label: 'Chamorro' },
  { code: 'chk', label: 'Chuukese' },
  { code: 'chm', label: 'Mari (Russia)' },
  { code: 'co', label: 'Corsican' },
  { code: 'cs', label: 'Czech' },
  { code: 'cu', label: 'Church Slavic' },
  { code: 'cv', label: 'Chuvash' },
  { code: 'cy', label: 'Welsh' },
  { code: 'da', label: 'Danish' },
  { code: 'de', label: 'German' },
  { code: 'doi', label: 'Dogri (macrolanguage)' },
  { code: 'dv', label: 'Dhivehi' },
  { code: 'dz', label: 'Dzongkha' },
  { code: 'ee', label: 'Ewe' },
  { code: 'el', label: 'Modern Greek (1453-)' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Spanish' },
  { code: 'et', label: 'Estonian' },
  { code: 'eu', label: 'Basque' },
  { code: 'fa', label: 'Persian' },
  { code: 'ff', label: 'Fulah' },
  { code: 'fi', label: 'Finnish' },
  { code: 'fil', label: 'Filipino' },
  { code: 'fj', label: 'Fijian' },
  { code: 'fo', label: 'Faroese' },
  { code: 'fr', label: 'French' },
  { code: 'fy', label: 'Western Frisian' },
  { code: 'ga', label: 'Irish' },
  { code: 'gd', label: 'Scottish Gaelic' },
  { code: 'gil', label: 'Gilbertese' },
  { code: 'gl', label: 'Galician' },
  { code: 'gn', label: 'Guarani' },
  { code: 'gu', label: 'Gujarati' },
  { code: 'gv', label: 'Manx' },
  { code: 'ha', label: 'Hausa' },
  { code: 'haw', label: 'Hawaiian' },
  { code: 'he', label: 'Hebrew' },
  { code: 'hi', label: 'Hindi' },
  { code: 'hil', label: 'Hiligaynon' },
  { code: 'ho', label: 'Hiri Motu' },
  { code: 'hr', label: 'Croatian' },
  { code: 'ht', label: 'Haitian' },
  { code: 'hu', label: 'Hungarian' },
  { code: 'hy', label: 'Armenian' },
  { code: 'hz', label: 'Herero' },
  { code: 'id', label: 'Indonesian' },
  { code: 'ig', label: 'Igbo' },
  { code: 'ilo', label: 'Iloko' },
  { code: 'inc', label: 'Indic languages' },
  { code: 'inh', label: 'Ingush' },
  { code: 'is', label: 'Icelandic' },
  { code: 'it', label: 'Italian' },
  { code: 'iu', label: 'Inuktitut' },
  { code: 'ja', label: 'Japanese' },
  { code: 'jv', label: 'Javanese' },
  { code: 'ka', label: 'Georgian' },
  { code: 'kbd', label: 'Kabardian' },
  { code: 'kg', label: 'Kongo' },
  { code: 'kk', label: 'Kazakh' },
  { code: 'kl', label: 'Kalaallisut' },
  { code: 'km', label: 'Central Khmer' },
  { code: 'kn', label: 'Kannada' },
  { code: 'ko', label: 'Korean' },
  { code: 'kok', label: 'Konkani (macrolanguage)' },
  { code: 'kos', label: 'Kosraean' },
  { code: 'kr', label: 'Kanuri' },
  { code: 'krc', label: 'Karachay-Balkar' },
  { code: 'ks', label: 'Kashmiri' },
  { code: 'ku', label: 'Kurdish' },
  { code: 'kv', label: 'Komi' },
  { code: 'ky', label: 'Kirghiz' },
  { code: 'la', label: 'Latin' },
  { code: 'lb', label: 'Luxembourgish' },
  { code: 'lg', label: 'Ganda' },
  { code: 'ln', label: 'Lingala' },
  { code: 'lo', label: 'Lao' },
  { code: 'loz', label: 'Lozi' },
  { code: 'lt', label: 'Lithuanian' },
  { code: 'lua', label: 'Luba-Lulua' },
  { code: 'lun', label: 'Lunda' },
  { code: 'lus', label: 'Lushai' },
  { code: 'lv', label: 'Latvian' },
  { code: 'mdf', label: 'Moksha' },
  { code: 'men', label: 'Mende (Sierra Leone)' },
  { code: 'mg', label: 'Malagasy' },
  { code: 'mh', label: 'Marshallese' },
  { code: 'mi', label: 'Maori' },
  { code: 'mk', label: 'Macedonian' },
  { code: 'ml', label: 'Malayalam' },
  { code: 'mn', label: 'Mongolian' },
  { code: 'mni', label: 'Manipuri' },
  { code: 'mos', label: 'Mossi' },
  { code: 'mr', label: 'Marathi' },
  { code: 'ms', label: 'Malay (macrolanguage)' },
  { code: 'mt', label: 'Maltese' },
  { code: 'mwl', label: 'Mirandese' },
  { code: 'my', label: 'Burmese' },
  { code: 'myv', label: 'Erzya' },
  { code: 'na', label: 'Nauru' },
  { code: 'nb', label: 'Norwegian Bokmål' },
  { code: 'nd', label: 'North Ndebele' },
  { code: 'ne', label: 'Nepali (macrolanguage)' },
  { code: 'niu', label: 'Niuean' },
  { code: 'nl', label: 'Dutch' },
  { code: 'nn', label: 'Norwegian Nynorsk' },
  { code: 'no', label: 'Norwegian' },
  { code: 'nog', label: 'Nogai' },
  { code: 'nr', label: 'South Ndebele' },
  { code: 'nso', label: 'Pedi' },
  { code: 'ny', label: 'Nyanja' },
  { code: 'oc', label: 'Occitan (post 1500)' },
  { code: 'om', label: 'Oromo' },
  { code: 'or', label: 'Oriya (macrolanguage)' },
  { code: 'pa', label: 'Panjabi' },
  { code: 'pag', label: 'Pangasinan' },
  { code: 'pam', label: 'Pampanga' },
  { code: 'pap', label: 'Papiamento' },
  { code: 'pau', label: 'Palauan' },
  { code: 'pl', label: 'Polish' },
  { code: 'pon', label: 'Pohnpeian' },
  { code: 'ps', label: 'Pushto' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'qu', label: 'Quechua' },
  { code: 'rm', label: 'Romansh' },
  { code: 'rn', label: 'Rundi' },
  { code: 'ro', label: 'Romanian' },
  { code: 'rom', label: 'Romany' },
  { code: 'ru', label: 'Russian' },
  { code: 'rw', label: 'Kinyarwanda' },
  { code: 'sa', label: 'Sanskrit' },
  { code: 'sah', label: 'Yakut' },
  { code: 'sat', label: 'Santali' },
  { code: 'sc', label: 'Sardinian' },
  { code: 'sd', label: 'Sindhi' },
  { code: 'se', label: 'Northern Sami' },
  { code: 'sg', label: 'Sango' },
  { code: 'si', label: 'Sinhala' },
  { code: 'sid', label: 'Sidamo' },
  { code: 'sit', label: 'Sino-Tibetan languages' },
  { code: 'sk', label: 'Slovak' },
  { code: 'sl', label: 'Slovenian' },
  { code: 'sm', label: 'Samoan' },
  { code: 'sma', label: 'Southern Sami' },
  { code: 'smn', label: 'Inari Sami' },
  { code: 'sn', label: 'Shona' },
  { code: 'snk', label: 'Soninke' },
  { code: 'so', label: 'Somali' },
  { code: 'sq', label: 'Albanian' },
  { code: 'sr', label: 'Serbian' },
  { code: 'srn', label: 'Sranan Tongo' },
  { code: 'ss', label: 'Swati' },
  { code: 'st', label: 'Southern Sotho' },
  { code: 'sv', label: 'Swedish' },
  { code: 'sw', label: 'Swahili (macrolanguage)' },
  { code: 'ta', label: 'Tamil' },
  { code: 'te', label: 'Telugu' },
  { code: 'tem', label: 'Timne' },
  { code: 'tet', label: 'Tetum' },
  { code: 'tg', label: 'Tajik' },
  { code: 'th', label: 'Thai' },
  { code: 'ti', label: 'Tigrinya' },
  { code: 'tig', label: 'Tigre' },
  { code: 'tk', label: 'Turkmen' },
  { code: 'tkl', label: 'Tokelau' },
  { code: 'tl', label: 'Tagalog' },
  { code: 'tn', label: 'Tswana' },
  { code: 'to', label: 'Tonga (Tonga Islands)' },
  { code: 'tpi', label: 'Tok Pisin' },
  { code: 'tr', label: 'Turkish' },
  { code: 'ts', label: 'Tsonga' },
  { code: 'tt', label: 'Tatar' },
  { code: 'tum', label: 'Tumbuka' },
  { code: 'tut', label: 'Altaic languages' },
  { code: 'tvl', label: 'Tuvalu' },
  { code: 'tw', label: 'Twi' },
  { code: 'ty', label: 'Tahitian' },
  { code: 'tyv', label: 'Tuvinian' },
  { code: 'udm', label: 'Udmurt' },
  { code: 'ug', label: 'Uighur' },
  { code: 'uk', label: 'Ukrainian' },
  { code: 'ur', label: 'Urdu' },
  { code: 'uz', label: 'Uzbek' },
  { code: 've', label: 'Venda' },
  { code: 'vi', label: 'Vietnamese' },
  { code: 'war', label: 'Waray (Philippines)' },
  { code: 'wo', label: 'Wolof' },
  { code: 'xal', label: 'Kalmyk' },
  { code: 'xh', label: 'Xhosa' },
  { code: 'yao', label: 'Yao' },
  { code: 'yap', label: 'Yapese' },
  { code: 'yo', label: 'Yoruba' },
  { code: 'za', label: 'Zhuang' },
  { code: 'zh', label: 'Chinese' },
  { code: 'zu', label: 'Zulu' },
];
